import fetch from 'isomorphic-fetch';
import {commonErrorHandler, commonHeaders} from './fetch.util';

export const TAX_INVOICES_REQUEST = 'TAX_INVOICES_REQUEST';
export const TAX_INVOICES_RESPONSE = 'TAX_INVOICES_RESPONSE';

function taxInvoicesRequest() {
  return {
    type: TAX_INVOICES_REQUEST,
  };
}

function taxInvoicesResponse(taxInvoices) {
  return {
    type: TAX_INVOICES_RESPONSE,
    taxInvoices,
  };
}

export function fetchTaxInvoicesForCurrentUser(year) {
  return dispatch => {
    dispatch(taxInvoicesRequest());
    fetch(`${API_URL}/tax-invoices/current-user/by-year/${year}`, {
      method: 'GET',
      headers: commonHeaders(),
    })
      .then(commonErrorHandler)
      .then(response => response.json())
      .then(taxInvoices => dispatch(taxInvoicesResponse(taxInvoices)));
  };
}
